var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { IDENTIFIER_TAB, IDENTIFIER_TAB_ITEM } from 'src/ui/components/Tabs/constants';
import { getApplicantPosition, isApplicantPositionDisplayed } from 'src/ui/components/Tabs/helpers';
import styles from './Tabs.module.scss';
export var Tabs = function (props) {
    var applicants = props.applicants, tabs = props.tabs, currentTab = props.currentTab, onChange = props.onChange;
    var handleTabChange = function (e, tab) {
        e.stopPropagation();
        onChange(tab);
    };
    return (_jsx("div", __assign({ "data-test": IDENTIFIER_TAB, className: styles.tabWrapper }, { children: tabs.map(function (tab, index) {
            var _a, _b;
            var isSelected = currentTab.id === tab.id;
            var applicantIndex = getApplicantPosition(tabs, tab.applicantId);
            var tabIndexClass = classNames(styles.tabIndex, isApplicantPositionDisplayed(applicants, tab.applicantId) ? styles.tabIndexDisplayed : null);
            return (_jsxs("div", __assign({ "data-test": IDENTIFIER_TAB_ITEM, className: classNames(styles.tab, isSelected ? styles.currentTab : null), onClick: isSelected ? undefined : function (e) { return handleTabChange(e, tab); }, style: { backgroundColor: isSelected ? (_a = tab.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor : null } }, { children: [tab.tooltip && (_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.BOTTOM, className: styles.tabTooltip }, { children: tab.tooltip }))), _jsx(Icons, { icon: tab.icon, color: (_b = tab.colors) === null || _b === void 0 ? void 0 : _b.color }), _jsx("span", __assign({ className: tabIndexClass }, { children: applicantIndex }))] }), index));
        }) })));
};
